var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('common-button', {
    attrs: {
      "disabled": _vm.isSubmitting,
      "icon": "trash",
      "type": "danger"
    },
    on: {
      "click": _vm.revokeAllTokensWhenConfirmed
    }
  }, [_vm._v(_vm._s(_vm.$t('text')))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-782f8e48","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/RevokeAllTokensButton.vue
// module id = 2065
// module chunks = 0